import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { ISapTypeOptions } from "interfaces/sap-type";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_SAP_TYPES_" }
);

export interface ListSapTypesState extends IState {
  data: ISapTypeOptions[];
}

interface ISuccessListSapTypesAction extends ISuccessAction {
  data: ISapTypeOptions[];
}

const INITIAL_STATE: ListSapTypesState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListSapTypesState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ListSapTypesState, action: ISuccessListSapTypesAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListSapTypesState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listSapTypes = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListSapTypesTypes = Types;
export const ListSapTypesActions = Creators;


